import Module, { moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import { EightDayView } from "./eightday_view";

const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit("EightDayActivity")
export class EightDayActivity extends Module<EightDayView,null> {
    constructor() {
        super()
        this.windowPrefabResPath = "package/hall/module/eightday/eightday";
        this.viewType = EightDayView;
        this.modelType = null
        this.needAnim = true
        this.needViewMask = true
        this.needDeferShow = true
    }

    onInit(){
        this.view.initView();
       
    }

    onDeferShow(){
        this.view.setTaskData();
        this.show();
    }

    @bindButtonClickEvent('leftBtn')
    onClickLeftBtn(){
    }

    @bindButtonClickEvent('rightBtn')
    onClickRightBtn(){
    }

}
